var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sendCode__button"},[(_vm.sendStatus)?_c('span',[_vm._v(" "+_vm._s((_vm.count + "s"))+" ")]):_c('span',{on:{"click":_vm.handleSend}},[_vm._v("发送验证码")])])}
var staticRenderFns = []

export { render, staticRenderFns }